import { stringify } from 'querystring';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AgentForm } from '../../agents/model/agent.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AgentService } from '../../agents/agent.service';


@Component({
  selector: 'app-add-agent',
  templateUrl: './add-agent.component.html',
  styleUrls: ['./add-agent.component.css']
})
export class AddAgentComponent implements OnInit {
  submitted: boolean = false;
  form: FormGroup;
  formBuilder: any;
  pwd: boolean = true
  cdata: any
  smtp: any = []
  edit: any = 0;
  sup: any;
  calendar: any;
  agentGroupID: any = [];

  dropdownSettings = {}
  dropdownSettings1 = {}
  dropdownSettingsSkill = {}
  dropdownSettingsLanguage = {}
  dropdownList = []
  dropdownList1 = []
  skillOptions: any[] = []
  languageOptions: any[] = []

  Idagent: any = []
  settings = {
    idField: 'id',
    textField: 'number',
    typeField: 'type',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: false,
    enableCheckAll: false,
    closeDropDownOnSelection: false,
    showSelectedItemsAtTop: false,
    defaultOpen: false
  };
  public aldid: any[] = [];
  public checkusername: boolean = false
  constructor(protected fb: FormBuilder, @Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<AddAgentComponent>, public data1: AgentService) {


    this.dropdownSettings = {
      singleSelection: false,
      idField: 'emailId',
      textField: 'username',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      // allowSearchFilter: true
    };

    this.dropdownSettings1 = {
      singleSelection: false,
      idField: 'id',
      textField: 'provider_name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      // allowSearchFilter: true
    };

    this.dropdownSettingsSkill = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
    };

    this.dropdownSettingsLanguage = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
    };


    this.edit = this.data.edit
    if (this.edit) {
      this.cdata = new AgentForm(this.data.data);
      this.form = this.cdata.makeform(this.fb);
    }
    else {
      this.cdata = new AgentForm(null);
      this.form = this.cdata.makeform(this.fb);
    }
  }

  ngOnInit() {
    if(this.data){
      console.log('getting data here ???""""++++', this.data);
      this.dropdownList = this.data.smtp
      // this.smtp=this.data.smtp
      // this.calendar=this.data.calendar
      this.dropdownList1 = this.data.calendar
      this.agentGroupID = this.data.agentgroupid
      this.sup = this.data.sup;
      this.Idagent = this.data.id
      this.getDID(this.data);
      if (this.data.data.wrap_up_time)
        this.form.patchValue({ "wrap_up_time": this.data.data.wrap_up_time })
    }

    this.data1.getSkills().subscribe((res: any) => {
      this.skillOptions = res || [];
    });
    this.data1.getLanguages().subscribe((res: any) => {
      this.languageOptions = res || [];
    });

  }
  get f1() {
    return this.form.controls;
  }
  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.form.invalid) {
      return;
    }

    if (this.cdata.saveForm(this.form) && this.checkusername == false) {
      this.cdata.agentgroupid = this.agentGroupID
      this.dialogRef.close(this.cdata)
    }
    this.submitted = false;
  }


  close() {
    this.dialogRef.close();
  }

  checkuser(ele: any) {
    this.data1.getService("getcheckuserdata", JSON.stringify({ username: ele.target.value })).subscribe(res => {
      this.checkusername = true
    }, err => {
      this.checkusername = false
    })
  }

  getDID(data: any) {
    console.log("for where condition ", data);
    let agentdata = data.edit == 0 ? { agentgroup: data.data.id, didgroupid: data.data.didgroupid, edit: data.edit } : { agent_id: data.data.id, didgroupid: data.data.didgroupid, edit: data.edit, agentgroup: data.agentgroupid }
    console.log("agentdata", agentdata)
    this.data1.getagentDIDs(agentdata).subscribe(res => {
      console.log('rrrr', res)
      let assigndata = []
      res.data.forEach(ele => {
        assigndata.push(ele.id_did)
      });
      let newArray = res.record.filter(ele => !assigndata.includes(ele.id));
      console.log('ttt', newArray)
      this.aldid = newArray
    })
  }

}
